export default __webpack_public_path__ + "static/life-grid-white-min-023b833aebfbb95b10f6638da7cb4326.png";